"use client";

import { useMemo } from 'react';
import styles from './_hcp-stat-callout.module.scss';

function HcpStatCallout({
  ref,
  className = '',
  colorTheme = 'purple',
  children = null,
}) {
  const themeClassName = colorTheme === 'orange' ? styles.orange : styles.purple;

  const componentClassName = useMemo(() => {
    return [
      styles.stat_callout,
      themeClassName,
      className,
    ].filter(Boolean).join(' ');
  }, [themeClassName, className]);

  return (
    <section ref={ref} className={componentClassName}>
      <p className={styles.copy}>{children}</p>
    </section>
  );
}

export default HcpStatCallout;
